import { render, staticRenderFns } from "./WestChinaDetail.vue?vue&type=template&id=65019f5b&scoped=true"
var script = {}
import style0 from "./WestChinaDetail.vue?vue&type=style&index=0&id=65019f5b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65019f5b",
  null
  
)

export default component.exports